import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class RowNumber extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.rownumber',
        group: 'Data Preparation',
        title: 'Row number',
        description: `This component creates a new table with an additional column containing row numbers.`
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Redshift:
      case Provider.Postgres:
        return dedent`SELECT ROW_NUMBER() OVER () AS row_num, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Snowflake:
        return dedent`SELECT ROW_NUMBER() OVER (ORDER BY 1) AS row_num, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  ROW_NUMBER() OVER (ORDER BY 1) AS row_num, *
                FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'row_count',
      type: ColumnDataType.Number
    })
  }

  getVersion(provider: Provider): string {
    return '2'
  }
}

export { RowNumber }
